<script>
  import { page } from "$app/stores";
</script>

<div>
  {#if $page?.status == 500}
    <div class="server-error-page">
      <div class="error-image">
        <img src="/images/error-page/shutterstock_535474714.jpg" alt="" />
      </div>
      <div class="error-message">
        <h2>Whoops!</h2>
        <h4>We are cleaning the mess</h4>
        <a href="/" data-sveltekit-reload>Go back</a>
      </div>
    </div>
  {:else if $page?.status == 404}
    <div class="server-error-page">
      <div class="error-image">
        <img src="/images/error-page/shutterstock_535474714.jpg" alt="" />
      </div>
      <div class="error-message">
        <h2>Whoops! 404</h2>
        <h4>We are cleaning the mess</h4>
        <a href="/" data-sveltekit-reload>Go back</a>
      </div>
    </div>
  {/if}
</div>

<style>
  .server-error-page {
    width: 100svw;
    height: calc(100svh - var(--header-height) - 50px);
    display: grid;
    grid-template-columns: 1.6fr 1fr;
    grid-template-rows: 100%;
    align-items: center;
    margin: 0 auto;
    padding: 0 40px;
  }
  .error-image {
    width: 90%;
    height: 100%;
  }
  .error-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .error-message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    color: #1f2525;
    font-family: "gotham-medium";
  }
  .error-message h2 {
    margin: 0;
    font-size: 3.5em;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .error-message h4 {
    font-size: 2.25em;
    font-family: "gotham-book";
    font-weight: 400;
    margin-bottom: 70px;
    letter-spacing: 2px;
    text-wrap: nowrap;
  }

  .error-message a {
    padding: 15px 40px;
    font-size: 1.2em;
    line-height: 1;
    text-decoration: none;
    text-transform: uppercase;
    background-color: #1f2525;
    color: #fdfdfd;
    font-family: "gotham-medium";
    border-radius: 30px;
    cursor: pointer;
  }

  @media (orientation: portrait) {
    .server-error-page {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 2fr;
    }
  }
  @media (max-width: 767px) {
    .server-error-page {
      padding: 10px;
    }
    .error-message h2 {
      font-size: 3em;
    }
    .error-message h4 {
      font-size: 1.6em;
      letter-spacing: 1.5px;
    }
  }
</style>
